import React from "react";

const SegLogo = ({
  src,
  alt = "Logo",
  className = "w-25 h-20 h-auto",
}) => {
  const imageSrc = typeof src === 'string' ? src : src?.default || src;

  return (
    <div className="w-full flex justify-center items-center bg-blue-600 py-5">
      <img
        src={imageSrc}
        alt={alt}
        loading="eager"
        className={className}
        onError={(e) => {
          console.error('Logo image failed to load:', imageSrc);
        }}
      />
    </div>
  );
};

export default SegLogo;
